import { ContentData } from "../../src/apis/stateful-content";
import { ColumnTypes } from "../../src/components/stateful-content/stateful-table/column-types";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

enum ShopType {
    BENDING = "bending",
    PUNCHING = "punching",
    SPAREPARTS = "spareparts",
}

const response: ContentData = {
    totalCount: 31,
    displayedCount: 31,
    isCreateCaseAllowed: true,
    schema: {
        name: {
            type: ColumnTypes.DiscontinuedInfo,
            sortable: true,
            "primary-mobile": true,
        },
        isFav: {
            type: ColumnTypes.FavToggle,
            sortable: true,
            "primary-mobile": false,
        },
        number: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
        constructionYear: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
        subEquipments: {
            type: ColumnTypes.Equipment,
            sortable: true,
            "primary-mobile": false,
        },
        location: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
        serviceAgreement: {
            type: ColumnTypes.Text,
            sortable: false,
            "primary-mobile": false,
        },
        softwareUpdates: {
            type: ColumnTypes.Status,
            sortable: false,
            "primary-mobile": false,
        },
        details: {
            type: ColumnTypes.DetailLink,
            sortable: false,
            "primary-mobile": false,
        },
    },
    items: [
        {
            name: "TruLaser Station 7001",
            number: "2856TWDEDM01",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    linkText: "Spare Parts",
                    shopType: ShopType.SPAREPARTS,
                },
                {
                    link: "#",
                    linkText: "Bending Tools",
                    shopType: ShopType.BENDING,
                },
            ],
            chooseShopTitle: "Test",
            serviceCallModalLink:
                "/mock-data/service-calls/create-service-call.html",
            discontinued: {
                status: "soc",
                type: "machine",
                date: "XX.XX.XXXX",
                head: "Das Produkt wird zum 31.12.2021 abgekündigt.",
                text: "Leider kann deshalb nur ein eingeschränkter Support zur Verfügung gestellt werden. Sollten Sie Fragen zur Abkündigung haben, wenden Sie sichgerne an Ihren Service-Ansprechpartner bei TRUMPF.",
                link: "http://www.google.com",
                extendedSupport: false,
            },
            image: "https://www.trumpf.com/filestorage/TRUMPF_Processed/_processed_/0/1/csm_TruLaser-Cell-7040-fiber-product-picture_fb999e34ef_cb6aaa0d91.jpg",
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },

            constructionYear: "2020",
            subEquipments: 5,
            location: "Ditzingen",
            serviceAgreement: "classic",
            softwareUpdates: "SOFTWARE_UPDATES_AllUpdatesSubscribed",
        },
        {
            name: "TruLaser Station 7001 Long Machine Name",
            number: "TWDEDM02",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    linkText: "Spare Parts",
                    shopType: ShopType.SPAREPARTS,
                },
                {
                    link: "#",
                    linkText: "Bending Tools",
                    shopType: ShopType.BENDING,
                },
            ],
            serviceCallModalLink:
                "/mock-data/service-calls/create-service-call.html",
            discontinued: {
                status: "soc",
                type: "equipment",
                date: "XX.XX.XXXX",
                head: "Das Produkt wird zum 31.12.2021 abgekündigt.",
                text: "Leider kann deshalb nur ein eingeschränkter Support zur Verfügung gestellt werden. Sollten Sie Fragen zur Abkündigung haben, wenden Sie sichgerne an Ihren Service-Ansprechpartner bei TRUMPF.",
                link: "http://www.google.com",
                extendedSupport: true,
            },
            image: "https://www.trumpf.com/filestorage/TRUMPF_Processed/_processed_/0/1/csm_TruLaser-Cell-7040-fiber-product-picture_fb999e34ef_cb6aaa0d91.jpg",
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            constructionYear: "2020",
            subEquipments: 5,
            location: "Ditzingen",
            serviceAgreement: "classic",
        },
        {
            name: "TruLaser Station 7001",
            number: "TWDEDM03",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    linkText: "Spare Parts",
                    shopType: ShopType.SPAREPARTS,
                },
                {
                    link: "#",
                    linkText: "Bending Tools",
                    shopType: ShopType.BENDING,
                },
            ],
            serviceCallModalLink:
                "/mock-data/service-calls/create-service-call.html",
            discontinued: {
                status: "soc",
                type: "equipment",
                date: "XX.XX.XXXX",
                head: "Das Produkt wird zum 31.12.2021 abgekündigt.",
                text: "Leider kann deshalb nur ein eingeschränkter Support zur Verfügung gestellt werden. Sollten Sie Fragen zur Abkündigung haben, wenden Sie sichgerne an Ihren Service-Ansprechpartner bei TRUMPF.",
                link: "http://www.google.com",
                extendedSupport: false,
            },
            image: "https://www.trumpf.com/filestorage/TRUMPF_Processed/_processed_/0/1/csm_TruLaser-Cell-7040-fiber-product-picture_fb999e34ef_cb6aaa0d91.jpg",
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            constructionYear: "2020",
            subEquipments: 0,
            location: "Ditzingen",
            serviceAgreement: "classic",
            softwareUpdates:
                "SOFTWARE_UPDATES_InstallationFailedOfSecurityUpdate",
        },
        {
            name: "TruLaser Station 7002",
            number: "TWDEDM104",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    linkText: "Spare Parts",
                    shopType: ShopType.SPAREPARTS,
                },
                {
                    link: "#",
                    linkText: "Punching Tools",
                    shopType: ShopType.PUNCHING,
                },
            ],
            serviceCallModalLink: "",
            discontinued: {
                status: "sod",
                type: "equipment",
                date: "XX.XX.XXXX",
                head: "Das Produkt wurde zum 31.12.2021 abgekündigt.",
                text: "Leider kann deshalb nur ein eingeschränkter Support zur Verfügung gestellt werden. Sollten Sie Fragen zur Abkündigung haben, wenden Sie sichgerne an Ihren Service-Ansprechpartner bei TRUMPF.",
                link: "http://www.google.com",
                extendedSupport: false,
            },
            image: "https://www.trumpf.com/filestorage/TRUMPF_Processed/_processed_/2/7/csm_TruLaser-Cell-5030-product-picture_8f7b06031b_8f1c37fb0b.jpg",
            isFav: {
                toggleUrl: "#toggleurl",
                active: true,
            },
            constructionYear: "2020",
            subEquipments: 5,
            location: "Ditzingen",
            serviceAgreement: "",
        },
        {
            name: "TruLaser Station 7001",
            number: "TWDEDM005",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    linkText: "Spare Parts",
                    shopType: ShopType.SPAREPARTS,
                },
            ],
            serviceCallModalLink: "",
            discontinued: {
                status: "sod",
                type: "machine",
                date: "XX.XX.XXXX",
                head: "Das Produkt wurde zum 31.12.2021 abgekündigt.",
                text: "Leider kann deshalb nur ein eingeschränkter Support zur Verfügung gestellt werden. Sollten Sie Fragen zur Abkündigung haben, wenden Sie sichgerne an Ihren Service-Ansprechpartner bei TRUMPF.",
                link: "http://www.google.com",
                extendedSupport: true,
            },
            image: "https://www.trumpf.com/filestorage/TRUMPF_Processed/_processed_/0/1/csm_TruLaser-Cell-7040-fiber-product-picture_fb999e34ef_cb6aaa0d91.jpg",
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            constructionYear: "2020",
            subEquipments: 5,
            location: "Ditzingen",
            serviceAgreement: "",
            softwareUpdates: "SOFTWARE_UPDATES_UpdatesNotSubscribed",
        },
        {
            name: "TruLaser Station 7002",
            number: "TWDEDM1016",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    linkText: "Spare Parts",
                    shopType: ShopType.SPAREPARTS,
                },
            ],
            serviceCallModalLink: "",
            image: "https://www.trumpf.com/filestorage/TRUMPF_Processed/_processed_/2/7/csm_TruLaser-Cell-5030-product-picture_8f7b06031b_8f1c37fb0b.jpg",

            isFav: {
                toggleUrl: "#toggleurl",
                active: true,
            },
            constructionYear: "2020",
            subEquipments: 5,
            location: "Ditzingen",
            serviceAgreement: "basic",
        },
        {
            name: "TruLaser Station 7001",
            number: "TWDEDM0007",
            detailLink: "#",
            shopLinks: null,
            serviceCallModalLink: "",
            image: "https://www.trumpf.com/filestorage/TRUMPF_Processed/_processed_/0/1/csm_TruLaser-Cell-7040-fiber-product-picture_fb999e34ef_cb6aaa0d91.jpg",
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            constructionYear: "2020",
            subEquipments: 5,
            location: "Ditzingen",
            serviceAgreement: "",
            softwareUpdates: "SOFTWARE_UPDATES_UpdatesPartiallySubscribed",
        },
        {
            name: "TruLaser Station 7002",
            number: "TWDEDM1028",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    linkText: "Spare Parts",
                    shopType: ShopType.SPAREPARTS,
                },
            ],
            serviceCallModalLink: "",
            image: "https://www.trumpf.com/filestorage/TRUMPF_Processed/_processed_/2/7/csm_TruLaser-Cell-5030-product-picture_8f7b06031b_8f1c37fb0b.jpg",
            isFav: {
                toggleUrl: "#toggleurl",
                active: true,
            },
            constructionYear: "2020",
            subEquipments: 5,
            location: "Ditzingen",
            serviceAgreement: "",
        },
        {
            name: "TruLaser Station 7001",
            number: "TWDEDM00009",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    linkText: "Spare Parts",
                    shopType: ShopType.SPAREPARTS,
                },
            ],
            serviceCallModalLink: "",
            image: "https://www.trumpf.com/filestorage/TRUMPF_Processed/_processed_/0/1/csm_TruLaser-Cell-7040-fiber-product-picture_fb999e34ef_cb6aaa0d91.jpg",
            isFav: {
                toggleUrl: "#toggleurl",
                active: false,
            },
            constructionYear: "2020",
            subEquipments: 5,
            location: "Ditzingen",
            serviceAgreement: "",
            softwareUpdates:
                "SOFTWARE_UPDATES_WaitingForInstallationOfSecurityUpdate",
        },
        {
            name: "TruLaser Station 7002",
            number: "TWDEDM10300",
            detailLink: "#",
            shopLinks: [
                {
                    link: "#",
                    linkText: "Spare Parts",
                    shopType: ShopType.SPAREPARTS,
                },
            ],
            serviceCallModalLink: "",
            image: "https://www.trumpf.com/filestorage/TRUMPF_Processed/_processed_/2/7/csm_TruLaser-Cell-5030-product-picture_8f7b06031b_8f1c37fb0b.jpg",
            isFav: {
                toggleUrl: "#toggleurl",
                active: true,
            },
            constructionYear: "2020",
            subEquipments: 5,
            location: "Ditzingen",
            serviceAgreement: "",
        },
    ],
};

const responseWithAssetManagement: ContentData = {
    ...response,
    items: response.items.map((item) => ({
        ...item,
        image: "https://api-s.trumpf.com/asset-management/1.0/images/asset-types/TRBV85SX/media/images/TB%20V%2085%20S_08_03_RGB.jpg",
    })),
    authImages: true,
};

const responseCaseCreationDisabled = {
    ...response,
    isCreateCaseAllowed: false,
};

const emptyResponse: ContentData = {
    totalCount: 0,
    displayedCount: 0,
    items: [],
    error: {
        head: "Sie besitzen noch keine Trumpf Maschinen",
        copy: "Lernen sie unsere Maschinen kennen und kontaktieren sie ihren zuständigen Trumpf Ansprechpartner.",
    },
};

const filteredEmptyResponse: ContentData = {
    totalCount: 31,
    displayedCount: 0,
    schema: {
        isFav: {
            type: ColumnTypes.FavToggle,
            sortable: true,
            "primary-mobile": false,
        },
        name: {
            type: ColumnTypes.DiscontinuedInfo,
            sortable: true,
            "primary-mobile": true,
        },
        number: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
        constructionYear: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
        subEquipments: {
            type: ColumnTypes.Equipment,
            sortable: true,
            "primary-mobile": false,
        },
        location: {
            type: ColumnTypes.Text,
            sortable: true,
            "primary-mobile": false,
        },
        serviceAgreement: {
            type: ColumnTypes.Text,
            sortable: false,
            "primary-mobile": false,
        },
        softwareUpdates: {
            type: ColumnTypes.Status,
            sortable: false,
            "primary-mobile": false,
        },
        details: {
            type: ColumnTypes.DetailLink,
            sortable: false,
            "primary-mobile": false,
        },
    },
    items: [],
};

const response1 = {
    ...responseWithAssetManagement,
    nextPage: `generated-mock-data/mymachine-stateful-v2-2.json`,
};

const response2 = {
    ...response,
    nextPage: `generated-mock-data/mymachine-stateful-v2-3.json`,
};

const response3 = {
    ...response,
    nextPage: `generated-mock-data/mymachine-stateful-v2-4.json`,
};

const response4 = {
    ...response,
};

const writeToFile = (object: ContentData, name: string) => {
    console.log(JSON.stringify(object));
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(response1, "mymachine-stateful-v2");
writeToFile(response2, "mymachine-stateful-v2-2");
writeToFile(response3, "mymachine-stateful-v2-3");
writeToFile(response4, "mymachine-stateful-v2-4");
writeToFile(
    responseCaseCreationDisabled,
    "mymachine-stateful-v2-case-creation-disabled"
);
writeToFile(emptyResponse, "mymachine-stateful-v2-empty");
writeToFile(filteredEmptyResponse, "mymachine-stateful-v2-filtered-empty");
